module.exports = __webpack_public_path__ + "u4.no2.0e148cd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u4.no2.jpg
// module id = MAAw
// module chunks = 0